import { useContext } from 'react'
import { Button, Form, Input, message } from 'antd'
import { EasyModal, ModalContext, postMsg } from 'src/components'
import { mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'
import MD5 from 'md5'

const FormChild = () => {
  const handleSubmit = (values: any) => {
    const payload = {
      Keyword: mainStore.userinfo.ID,
      Parameter1: MD5(values.OldPassword),
      Parameter2: MD5(values.NewPassword)
    }

    $api['app/getDataByPost'](payload, {
      url: '/OP/User/UpdatePwd'
    }).then((res: any) => {
      if (res) {
        postMsg({
          type: 'success',
          content: '修改成功，请重新登录',
          duration: 3,
          onClose () {
            mainStore.logout()
          }
        })
      } else {
        message.error('操作失败')
      }
    })

  }

  const modal = useContext(ModalContext)
  const handleCancel = () => {
    modal.close()
  }

  return (
    <Form labelCol={{ span: 6 }} onFinish={handleSubmit}>
      <Form.Item label='旧密码' name='OldPassword' rules={[{ required: true }]}>
        <Input type='password' />
      </Form.Item>
      <Form.Item label='新密码' name='NewPassword' rules={[{ required: true }]}>
        <Input type='password' />
      </Form.Item>
      <Form.Item
        label='确认密码'
        dependencies={['NewPassword']}
        name='NewPasswordConfirm'
        rules={[
          { required: true, message: '请确认密码' },
          ({ getFieldValue }) => ({
            validator (_, value) {
              if (!value || getFieldValue('NewPassword') === value) {
                return Promise.resolve()
              }
              return Promise.reject(new Error('两次输入密码不一致'))
            },
          })
        ]}
      >
        <Input type='password' />
      </Form.Item>
      <Form.Item style={{ textAlign: 'center', marginTop: 16 }}>
        <Button type='primary' htmlType='submit'>确认</Button>
        <Button className='mg-l16' onClick={handleCancel}>取消</Button>
      </Form.Item>
    </Form>
  )
}

const ChangePassword = () => {
  return (
    <EasyModal
      modal={{ title: '修改密码', width: 500 }}
      slot={<span>修改密码</span>}
    >
      <FormChild />
    </EasyModal>
  )
}

export default ChangePassword